import {Injectable} from '@angular/core';
import {DictionaryService} from '../../shared/services/dictionary.service';
import {DocumentType} from '../../shared/models/DocumentType';

@Injectable({
  providedIn: 'root'
})
export class DocumentTypeService extends DictionaryService<DocumentType> {
  path = 'document_types';
}

